import { twMerge } from 'tailwind-merge';

// Ensures the latest class when conflicts, is used. (overrides)
export function classNames(...classes) {
  return twMerge(...classes);
}
